import { FiSearch, FiGrid, FiPlus, FiUsers, FiGitMerge } from "react-icons/fi";
import { BiSearch } from "react-icons/bi";
import { IoCloseSharp } from "react-icons/io5";
import GeneralButton from "../../components/button/GeneralButton";
import FormInput from "../../components/formInput/FormInput";
import AddNewAddress from "../../components/modals/AddNewAddress";
import MergeCustomerModal from "../../components/modals/MergeCustomerModal";
import CustomersTable from "../../components/table/CustomersTable";
import useCustomers from "./customHooks/useCustomers";
import { useState, useEffect } from "react";
import TableSkeleton from "../../components/skeleton/TableSkeleton";
const Customers = () => {
  const {
    modal,
    toggleCreateCustomer,
    customers,
    searchValue,
    setSearchValue,
    setCanSearch,
    setSelectedData,
    data,
    setData,
    page,
    setPage,
    pageSize,
    setPageSize,
    loading,
    totalPages,
    type, setType, gettingCustomers
  } = useCustomers();

  const [mergeModal, setMergeModal] = useState(false);
  const toggleMergeModal = () => setMergeModal((prev) => !prev);

  const [searchHistory, setSearchHistory] = useState(() => {
    try {
      const history = localStorage.getItem("customerSearchHistory");
      if (!history) return [];
      const parsed = JSON.parse(history);
      const now = Date.now();
      return parsed.filter(item => item.timestamp && (now - item.timestamp < 3600000));
    } catch (e) {
      return [];
    }
  });
  const [showHistory, setShowHistory] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setSearchHistory(prev => {
        const now = Date.now();
        const filtered = prev.filter(item => item.timestamp && (now - item.timestamp < 3600000));
        if (filtered.length !== prev.length) {
          localStorage.setItem("customerSearchHistory", JSON.stringify(filtered));
        }
        return filtered;
      });
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const clearSearch = () => {
    setSearchValue("");
    localStorage.removeItem("customerSearch");
    setPage(1);
  };

  const saveToHistory = (term) => {
    const cleanTerm = term?.trim();
    if (!cleanTerm || cleanTerm.length < 2) return;
    setSearchHistory((prev) => {
      const currentHistory = Array.isArray(prev) ? prev : [];
      const now = Date.now();
      const newHistory = [
        { term: cleanTerm, timestamp: now },
        ...currentHistory.filter((item) => item.term !== cleanTerm)
      ].slice(0, 10);
      localStorage.setItem("customerSearchHistory", JSON.stringify(newHistory));
      return newHistory;
    });
  };

  useEffect(() => {
    if (searchValue && searchValue.trim().length >= 3) {
      const timer = setTimeout(() => {
        saveToHistory(searchValue);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [searchValue]);

  const handleHistoryClick = (term) => {
    setSearchValue(term);
    setPage(1);
    localStorage.setItem("customerSearch", term);
    setShowHistory(false);
    saveToHistory(term);
  };

  const clearHistory = (e) => {
    e.stopPropagation();
    setSearchHistory([]);
    localStorage.removeItem("customerSearchHistory");
  };

  return (
    <div className="settings-container">
      <AddNewAddress
        modal={modal}
        toggle={() => {
          toggleCreateCustomer();
        }}
        data={data}
        setData={setData}
        gettingCustomers={gettingCustomers}
      />

      <MergeCustomerModal
        isOpen={mergeModal}
        toggle={toggleMergeModal}
        gettingCustomers={gettingCustomers}
        customerType={type}
      />

      <div className="px-4">
        {/* Header Section */}
        <div className="d-flex justify-content-between align-items-center mb-4 search-input-wrapper">
          <div className="d-flex align-items-center gap-3 flex-1">

            <div>
              <div className="d-flex align-items-center p-1 bg-light rounded-pill border" style={{ width: "fit-content" }}>
                <button
                  className={`btn rounded-pill border-0 fw-bold px-4 py-2 transition-all ${type === 'company' ? "btn-primary shadow-sm" : "bg-transparent text-muted"}`}
                  style={{ fontSize: "14px" }}
                  onClick={() => {
                    setType('company');
                    setPage(1);
                  }}
                >
                  B2B
                </button>
                <button
                  className={`btn rounded-pill border-0 fw-bold px-4 py-2 transition-all ${type === 'individual' ? "btn-primary shadow-sm" : "bg-transparent text-muted"}`}
                  style={{ fontSize: "14px" }}
                  onClick={() => {
                    setType('individual');
                    setPage(1);
                  }}
                >
                  B2C
                </button>
                <button
                  className={`btn rounded-pill border-0 fw-bold px-4 py-2 transition-all ${type === 'requests' ? "btn-primary shadow-sm" : "bg-transparent text-muted"}`}
                  style={{ fontSize: "14px" }}
                  onClick={() => {
                    setType('requests');
                    setPage(1);
                  }}
                >
                  Requests
                </button>
              </div>
              <p className="text-muted small mb-0 m-3">Records ({totalPages ?? 0} Total)</p>
            </div>
          </div>

          <div className="flex-1 d-flex justify-content-center">
            <div className="position-relative" style={{ width: "400px" }}>
              <FormInput
                type={"text"}
                placeholder={"Search customer..."}
                size={"large"}
                className="border-0 shadow-none"
                icon={<FiSearch size={"20"} className="text-muted" />}
                handleChange={(e) => {
                  setCanSearch(true);
                  setSearchValue(e.target.value);
                  setPage(1);
                  localStorage.setItem('customerSearch', e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    saveToHistory(searchValue);
                    setShowHistory(false);
                  }
                }}
                onFocus={() => setShowHistory(true)}
                onBlur={() => setTimeout(() => setShowHistory(false), 200)}
                value={searchValue}
                suffix={
                  searchValue ? (
                    <IoCloseSharp
                      size={18}
                      className="text-muted pointer"
                      onClick={clearSearch}
                    />
                  ) : null
                }
              />
              {showHistory && searchHistory.length > 0 && (
                <div
                  className="position-absolute w-100 bg-white border shadow-lg mt-1"
                  style={{
                    zIndex: 2000,
                    borderRadius: '4px',
                    maxHeight: '300px',
                    overflowY: 'auto',
                    top: '100%',
                    left: 0
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center p-2 border-bottom bg-light sticky-top">
                    <span className="text-muted small fw-bold">RECENT SEARCHES</span>
                    <span
                      className="text-primary small cursor-pointer fw-bold"
                      onClick={clearHistory}
                      style={{ cursor: 'pointer' }}
                    >
                      Clear All
                    </span>
                  </div>
                  {searchHistory.map((item, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center p-2 border-bottom"
                      style={{ cursor: 'pointer', transition: 'background 0.2s' }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      onClick={() => handleHistoryClick(item.term)}
                    >
                      <BiSearch size={16} className="text-muted me-2" />
                      <span className="flex-grow-1" style={{ fontSize: '14px', color: '#333' }}>{item.term}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="d-flex gap-3 flex-1 justify-content-end align-items-center">
            <GeneralButton
              title={"Merge Customer"}
              className={"red-button shadow-sm d-inline-flex align-items-center justify-content-center m-0"}
              height={"42px"}
              width={"200px"}
              handleClick={() => {
                toggleMergeModal();
              }}
              icon={<FiGitMerge />}
            />
            <GeneralButton
              title={"Create Customer"}
              className={"create-user-btn text-white shadow-sm d-inline-flex align-items-center justify-content-center m-0"}
              height={"42px"}
              width={"200px"}
              handleClick={() => {
                toggleCreateCustomer();
              }}
              icon={<FiPlus />}
            />
          </div>
        </div>

        <div className="settings-card">
          {loading ? (
            <TableSkeleton columns={8} />
          ) : (
            <CustomersTable
              customers={customers}
              setSelectedData={setSelectedData}
              searchValue={searchValue}
              page={page}
              totalPages={totalPages}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              gettingCustomers={gettingCustomers}
              onClearSearch={searchValue ? () => {
                setSearchValue("");
                setPage(1);
              } : undefined}
              onCreateNew={toggleCreateCustomer}
              onMerge={toggleMergeModal}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Customers;
